import { CURRENT_ANY_PROP_MAILING_ADDRESS, CURRENT_PROP_MAILING_ADDRESS, UPDATE_PROP_MAILING_ADDRESS } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction } from "../../types";

// Define an initial state value for the app
export const initialState: MailingAddressCurrent  = {
    address_data: false,
    submissions: false,
    submitted: false,
    found: false,
    loading: false,
    error: false
}

export interface MailingAddressDetails extends Record<string, unknown>{
    roll: string;
    unit: string;
    city: string;
    addr: string;
    postal_code: string;
    province: string;
    email: string;
    phone: string;
    user_profile_id: string;
    submission_id: string;
    submission_date: number;
    status: string
}

export interface MailingAddressCurrent {
    address_data: MailingAddressDetails | false;
    submissions: MailingAddressDetails [] | false;
    submitted: boolean;
    found: boolean;
    loading: boolean,
    error: boolean,
}


export function mailingAddressReducer(state = initialState, action: AppAction): MailingAddressCurrent {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case CURRENT_PROP_MAILING_ADDRESS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case CURRENT_PROP_MAILING_ADDRESS.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case CURRENT_PROP_MAILING_ADDRESS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case CURRENT_PROP_MAILING_ADDRESS.RESET:
            return {
                ...state,
                ...initialState
            };
        default:
            return state
        }
}

export function mailingAddressAnyReducer(state = initialState, action: AppAction): MailingAddressCurrent {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case CURRENT_ANY_PROP_MAILING_ADDRESS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case CURRENT_ANY_PROP_MAILING_ADDRESS.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case CURRENT_ANY_PROP_MAILING_ADDRESS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case CURRENT_ANY_PROP_MAILING_ADDRESS.RESET:
            return {
                ...state,
                ...initialState
            };
        default:
            return state
        }
}

export interface UpdateResponse {
    captcha: boolean,
    email_valid: boolean,
    submitted: boolean,
    submisssion_id?: number,
    loading: boolean,
    error: boolean,
    mq_error: boolean,
    db_error: boolean
}

const initialStateUpdate: UpdateResponse = {
    captcha: false,
    email_valid: false,
    submitted: false,
    loading: false,
    error: false,
    mq_error: false,
    db_error: false
}

export function updateMailingAddressReducer(state = initialStateUpdate, action: AppAction): UpdateResponse {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case UPDATE_PROP_MAILING_ADDRESS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case UPDATE_PROP_MAILING_ADDRESS.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case UPDATE_PROP_MAILING_ADDRESS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case UPDATE_PROP_MAILING_ADDRESS.RESET:
            return {
                ...state,
                ...initialState
            };
        default:
            return state
        }
}